import { Label } from "@/components/shadcn/label";

export const NAME_MAX = 64;

// Client-side preview of the snake_case identifier the backend derives from a
// display name. An approximation (the server has the final say on uniqueness),
// enough to show the user what they'll reference in SQL.
export function toSnakeCase(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^[^a-z]+/, "")
    .slice(0, NAME_MAX)
    .replace(/_$/, "");
}

// Read-only SQL identifier for a table or column, rendered like a form field
// (label + value) but disabled — consistent across the create/add/edit dialogs
// and the table Settings.
export function IdentifierField({
  identifier,
  helperText = "Used in queries and the API. Can't be changed after creation.",
}: {
  identifier: string;
  helperText?: string;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label>Identifier</Label>
      <div className="flex items-center rounded-md border bg-muted/40 px-3 py-2 font-mono text-sm text-muted-foreground">
        {identifier}
      </div>
      {helperText && (
        <p className="text-xs text-muted-foreground">{helperText}</p>
      )}
    </div>
  );
}
